import { render } from "./GameLeaderboardView.vue?vue&type=template&id=f89125ae"
import script from "./GameLeaderboardView.vue?vue&type=script&lang=js"
export * from "./GameLeaderboardView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__